const TERRA_AUTH_CALLBACK_HOST = 'terra-auth-callback'

type TerraAuthResult = { type: 'success'; url?: string } | { type: 'cancel' | 'dismiss' }

type TerraAuthResultHandlers = {
  onSuccess: () => void
  onFailure: () => void
  onCancel: () => void
}

export const getTerraAuthRedirectUrl = (scheme: string) => `${scheme}://${TERRA_AUTH_CALLBACK_HOST}`

export const getTerraAuthCallbackFailureReason = (callbackUrl: string) => {
  const encodedReason = callbackUrl.match(/[?&]reason=([^&#]*)/)?.[1]

  if (!encodedReason) {
    return
  }

  try {
    return decodeURIComponent(encodedReason.replace(/\+/g, ' '))
  } catch {
    return encodedReason
  }
}

const hasTerraAuthCallbackResource = (callbackUrl: string) =>
  /[?&]resource=([^&#]+)/.test(callbackUrl)

export const handleTerraAuthResult = (
  result: TerraAuthResult,
  { onSuccess, onFailure, onCancel }: TerraAuthResultHandlers,
) => {
  if (result.type !== 'success') {
    onCancel()
    return
  }

  if (
    !result.url ||
    !hasTerraAuthCallbackResource(result.url) ||
    getTerraAuthCallbackFailureReason(result.url)
  ) {
    onFailure()
    return
  }

  onSuccess()
}
